// Get elements from the DOM
var productsOnPage = document.querySelector('.products-onpage');
var loadMoreBtn = document.querySelector('.load-more_btn');
var loadMoreSpinner = document.querySelector('.load-more_spinner');

// Get the next URL from data attribute
var nextUrl = productsOnPage.getAttribute('data-next-url');

loadMoreSpinner.style.display = 'none';

// Function to load more products
function loadMoreProducts() {
  if (!nextUrl) return; // Exit if there's no URL to fetch

  console.log(nextUrl);

  // Show spinner and hide button
  loadMoreBtn.style.display = 'none';
  loadMoreSpinner.style.display = 'block';

  // Perform fetch request
  fetch(nextUrl)
    .then(response => response.text())
    .then(nextPageHtml => {
      // Hide spinner
      loadMoreSpinner.style.display = 'none';

      // Parse the response and find new products
      var parser = new DOMParser();
      var doc = parser.parseFromString(nextPageHtml, 'text/html');
      var newProducts = doc.querySelector('.products-onpage');
      var newUrl = newProducts ? newProducts.getAttribute('data-next-url') : null;

      // Show the button if there is a next URL
      if (newUrl) {
        loadMoreBtn.style.display = 'block';
      }

      // Update the next URL
      nextUrl = newUrl;

      // Append new products to the existing ones
      productsOnPage.innerHTML += newProducts ? newProducts.innerHTML : '';

      productsOnPage.querySelectorAll('.pi-flickity--carousel').forEach(item => {
        new Flickity(item, {
          adaptiveHeight: true, 
          watchCSS: true, 
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
          pageDots: true,
          selectedAttraction: 0.04
        });
      });

      productsOnPage.querySelectorAll('.variant-input-wrapper').forEach(item => {
        new Flickity(item, {
          cellAlign: 'center',
          contain: true,
          pageDots: false,
          freeScroll: true,
          groupCells: '100%',
        });
      });

      theme.initQuickShop();
      ezmModal();
    })
    .catch(error => {
      console.error('Error loading more products:', error);
      // Hide spinner and show button in case of error
      loadMoreSpinner.style.display = 'none';
      loadMoreBtn.style.display = 'block';
    });
}
